import {
  Box,
  Typography,
  useTheme,
  SxProps,
  Theme,
  IconButton,
  Slide,
} from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { useState, FC, useMemo } from "react"
import { QRCode } from "components/QRCode"
import { useExternalLink } from "extensions/iconsiam/hooks/external-link/useExternalLink"
import { useTranslation } from "providers/i18n"
import { deepmerge } from "@mui/utils"
import { getIcon } from "utils/icon"

interface TouristRegistrationPanelProps {
  sx?: SxProps<Theme>
}

export const TouristRegistrationPanel: FC<TouristRegistrationPanelProps> = ({
  sx = {},
}) => {
  const { externalLink } = useExternalLink()

  const [open, setOpen] = useState(true)

  const { t } = useTranslation()
  const theme = useTheme()
  const {
    root,
    triggerPanel,
    animationWrapper,
    contentContainer,
    header,
    informationWrapper,
    textContainer,
    primaryText,
    secondaryText,
    tertiaryText,
    qrCodeContainer,
    qrCode,
    iconButton,
  } = theme.components?.[`TouristRegistrationPanel`]?.styleOverrides || {}

  const isRtl = theme.isRtl

  const openIcon = useMemo(
    () => getIcon(theme?.assets?.nextIcon) || <ChevronRightIcon />,
    [theme]
  )

  const closeIcon = useMemo(
    () => getIcon(theme?.assets?.backIcon) || <ChevronLeftIcon />,
    [theme]
  )

  return (
    <Box sx={deepmerge(root, sx)}>
      {!open && (
        <Box sx={triggerPanel} onClick={() => setOpen(true)}>
          <IconButton className={isRtl ? "is-rtl" : ""} sx={iconButton}>
            {openIcon}
          </IconButton>
        </Box>
      )}

      {/* Paper Panel with Slide */}
      <Slide
        className={isRtl ? "is-rtl" : ""}
        direction={isRtl ? "left" : "right"}
        in={open}
        mountOnEnter
        unmountOnExit
        style={animationWrapper}
      >
        <Box
          sx={contentContainer}
          className={isRtl ? "is-rtl" : ""}
          onClick={() => setOpen(false)}
        >
          {/* Header */}
          <Box sx={header} />

          {/* Content */}
          <Box sx={informationWrapper}>
            <Box sx={textContainer}>
              <Typography sx={primaryText}>
                {t("discount & privileges")}
              </Typography>
              <Typography sx={secondaryText}>{t("for tourists")}</Typography>
              <Typography sx={tertiaryText}>
                {t("chinese description")}
              </Typography>
            </Box>
            <Box style={qrCodeContainer}>
              <QRCode
                url={externalLink}
                caption={t("scan to join")}
                sx={qrCode}
              />
            </Box>
          </Box>

          {/* Close Button */}
          <IconButton className={isRtl ? "is-rtl" : ""} sx={iconButton}>
            {closeIcon}
          </IconButton>
        </Box>
      </Slide>
    </Box>
  )
}
